<template>
  <div class="modal-backdrop" v-if="show">
    <div class="modal">
      <form>
        <!--<h5 class="description">Critère 1</h5>-->
        <Select
            v-model="critere1"
            description="Critère 1"
            :options="Critere"
            label="nom"
            placeholder="Aucun"
            @change="change"
          />
          <Select
            v-model="critere2"
            description="Critère 2"
            :options="Critere"
            label="nom"
            placeholder="Aucun"
             @change="change"
          />
          <Select
            v-model="critere3"
            description="Critère 3"
            :options="Critere"
            label="nom"
            placeholder="Aucun"
             @change="change"
          />
          <Select
            v-model="critere4"
            description="Critère 4"
            :options="Critere"
            label="nom"
            placeholder="Aucun"
             @change="change"
          />
          <Select
            v-model="critere5"
            description="Critère 5"
            :options="Critere"
            label="nom"
            placeholder="Aucun"
             @change="change"
          />
        <button type="button" class="btn" @click="change">Valider</button>
      </form>
    </div>
  </div>
</template>
<script>
//import { mapActions, mapGetters, mapMutations } from "vuex";
import Select from './Select'
export default {
  data() {
    return {

      Critere: [
        { value: "Rentabilité locative", nom: "Rentabilité locative" },
        { value: "Sécurité locative", nom: "Sécurité locative" },
        { value: "Attractivité du quartier", nom: "Attractivité du quartier" },
        { value: "Potentiel de plus-value", nom: "Potentiel de plus-value" },
        { value: "Facilité de la revente", nom: "Facilité de la revente" },  
      ],
      critere1:null,
      critere2:null,
      critere3:null,
      critere4:null,
      critere5:null,
    };
  },
  props: ["show"],
  methods: {
    change() {
      this.$emit('change')
      console.log(this.critere1,this.critere2,this.critere3,this.critere4,this.critere5);
    },
  },
  components: {
    Select
  },
  watch: {
    show: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler: function(show) {
        if (show) {
          //desactive scroll in body
          //document.body.style.setProperty("overflow", "hidden");
        } else {
          document.body.style.removeProperty("overflow");
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
.modal-backdrop {
  position: absolute;
  .modal {
    width: 100%;
    background-color: #f2fdff;
    border-radius: 3px;
    padding: 15px;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);
    margin-top: 15px;
    .description {
      margin: 0px;
      margin-bottom: 10px;
      color: #8a8383;
    }
    .btn {
      margin-top: 5px;
      width: 100%;
      border-radius: 5px;
      border: none;
      color: white;
      background-color: #22abc5;
      padding: 12px;
      outline: 0;
      font-size: 15px;
      font-family: Metropolis;
      &:focus {
        border: none;
        background-color: #ff8c00;
      }
    }
  }
}
@media screen and (max-width: 768px) {
.modal-backdrop{
  position: initial;
  .modal{
    width: 170px;
    padding:10px;
  }
}
}

</style>
